import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicRule, RuleEntity } from '@pdqdev/pdq-shared/dist/entities/Rules';
import { UrgencyBoostFormGroup } from '../../model';

@Component({
  selector: 'urgency-boost-form-display-conditions',
  templateUrl: './urgency-boost-form-display-conditions.component.html',
  styleUrls: ['./urgency-boost-form-display-conditions.component.scss'],
  standalone: false,
})
export class UrgencyBoostFormDisplayConditionsComponent implements OnInit {
  @Input() formGroup: FormGroup<UrgencyBoostFormGroup>;
  @Input() displayRules: DynamicRule[];

  displayRulesEntities: RuleEntity[];

  ngOnInit(): void {
    this.displayRulesEntities = (this.displayRules ?? []).map((r) => r.entity);
  }
}
